export default function UploadCloud(props) {
  return (
    <svg viewBox="0 0 23.355 16.751" {...props}>
      <defs>
        <clipPath id={`upload-cloud-path`}>
          <path fill="none" d="M0 0h23.355v16.751H0z" />
        </clipPath>
      </defs>
      <g opacity=".605" clipPath={`url(upload-cloud-path)`} fill="#231f20">
        <path d="M18.736 5.231a7.378 7.378 0 0 0-14.117 0 4.769 4.769 0 0 0 .15 9.536h3.4a.6.6 0 1 0 0-1.2c-1.248 0-1.978 0-2.4.043v-.042h-.99a3.567 3.567 0 0 1 0-7.134c.087 0 .174.006.259.014a.607.607 0 0 0 .634-.463 6.176 6.176 0 0 1 12.032 0 .607.607 0 0 0 .634.463c.085-.007.172-.014.26-.014a3.567 3.567 0 0 1 0 7.134H17.6v.042c-.427-.043-1.156-.043-2.4-.043a.6.6 0 0 0 0 1.2s2.291 0 2.4 0h1a4.769 4.769 0 0 0 .149-9.536" />
        <path d="M14.686 10.264a.6.6 0 0 0 .723-.96l-3.37-2.536-.008-.005-.03-.021-.012-.007-.034-.02a.6.6 0 0 0-.079-.033h-.01l-.031-.009-.022-.006-.028-.006h-.208l-.03.006-.02.005-.033.009h-.006a.6.6 0 0 0-.079.034h-.005l-.031.018-.015.009-.027.018-.01.007-3.369 2.536a.6.6 0 1 0 .723.96l2.407-1.812v7.7a.6.6 0 0 0 1.2 0v-7.7Z" />
      </g>
    </svg>
  );
}
